if (!customElements.get('custom-hero-slider')) {
  class CustomHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-slider]');
      this.slides = this.querySelectorAll('[data-slide]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.dots = this.querySelectorAll('[data-dot]');
      this.currentIndex = 0;
      this.autoplayTimer = null;

      if (!this.slider || this.slides.length === 0) return;

      this.setupListeners();
      this.updateDots();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    setupListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.goToPrev();
          this.resetAutoplay();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.goToNext();
          this.resetAutoplay();
        });
      }

      for (const [index, dot] of this.dots.entries()) {
        dot.addEventListener('click', () => {
          this.goToSlide(index);
          this.resetAutoplay();
        });
      }

      this.slider.addEventListener('scroll', () => {
        const scrollPos = this.slider.scrollLeft;
        const slideWidth = this.slider.clientWidth;
        this.currentIndex = Math.round(scrollPos / slideWidth);
        this.updateDots();
      });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('touchstart', () => this.stopAutoplay(), { passive: true });
      this.addEventListener('touchend', () => this.startAutoplay(), { passive: true });
    }

    goToNext() {
      const nextIndex = this.currentIndex >= this.slides.length - 1
        ? 0
        : this.currentIndex + 1;
      this.goToSlide(nextIndex);
    }

    goToPrev() {
      const prevIndex = this.currentIndex <= 0
        ? this.slides.length - 1
        : this.currentIndex - 1;
      this.goToSlide(prevIndex);
    }

    goToSlide(index) {
      const slide = this.slides[index];
      if (!slide) return;

      this.currentIndex = index;
      this.slider.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth',
      });
      this.updateDots();
    }

    updateDots() {
      for (const [index, dot] of this.dots.entries()) {
        dot.classList.toggle('active', index === this.currentIndex);
      }
    }

    startAutoplay() {
      const autoplayEnabled = this.dataset.autoplay === 'true';
      if (!autoplayEnabled || this.slides.length <= 1) return;

      this.stopAutoplay();
      const speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.autoplayTimer = setInterval(() => this.goToNext(), speed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  customElements.define('custom-hero-slider', CustomHeroSlider);
}
